import { type ICallPayload } from '@/types/ICallPayload';
import { formatCallAccountName } from './formatCallAccountName';

export interface ICallSummary {
  /** «Входящий/Пропущенный звонок с номера: …» */
  title: string;
  /** «Найден аккаунт в БД: Имя Фамилия» либо «Аккаунт в БД не найден». */
  subtitle: string;
  /** Путь к странице клиента либо `null`, если аккаунт не найден. */
  accountPath: string | null;
}

const INCOMING_TITLE = 'Входящий звонок с номера';
const MISSED_TITLE = 'Пропущенный звонок с номера';
const ACCOUNT_FOUND = 'Найден аккаунт в БД';
const ACCOUNT_NOT_FOUND = 'Аккаунт в БД не найден';
const ACCOUNT_WITHOUT_NAME = 'Найден аккаунт в БД: имя не указано';

/**
 * Готовит текстовую сводку звонка для тоста и заголовка модального окна.
 * Чистая функция — один источник формулировок для обоих сценариев
 * (живой входящий и пропущенный из истории).
 *
 * @param payload - нормализованные данные звонка
 * @returns заголовок, подпись и путь к аккаунту
 */
export const getCallSummary = (payload: ICallPayload): ICallSummary => {
  const { phone, account, source } = payload;
  const titlePrefix = source === 'missed' ? MISSED_TITLE : INCOMING_TITLE;
  const name = formatCallAccountName(account);

  const subtitle = (() => {
    if (account === null) {
      return ACCOUNT_NOT_FOUND;
    }
    return name === '' ? ACCOUNT_WITHOUT_NAME : `${ACCOUNT_FOUND}: ${name}`;
  })();

  // Карточка клиента открывается только по `uuid` (PAR-5189); без него
  // ссылке некуда вести.
  const accountUuid = account?.uuid ?? '';

  return {
    title: `${titlePrefix}: ${phone}`,
    subtitle,
    accountPath: accountUuid !== '' ? `/client/${accountUuid}` : null
  };
};
